import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    Button,
    NumberField,
    NumberInput,
    FormDataConsumer,
    WrapperField,
    FunctionField,
    TopToolbar,
    EditButton,
    Confirm,
    useDataProvider,
    useRedirect,
    useNotify,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    RichTextField,
    ReferenceInput,
    AutocompleteInput,
    Link,
} from 'react-admin';
import Grid from '@mui/material/Grid';
import { formStatuses, getStatuses, toSelectChoices } from "../helpers/strings";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { RichTextInput } from "ra-input-rich-text";
import { FormEditChildToolbar } from "../Components/FormEditChildToolbar";

const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const FormKeyIndicatorList = props => (
    <List title={"All Key Indicators"} filters={listFilters} {...props} hasCreate>
        <Datagrid rowClick="show">
            <TextField source="name" />

            <TextField label="Form" source="form_standard.form.name" />

            <TextField label="Standard" source="form_standard.name" />
        </Datagrid>
    </List>
);

const FormPreview = () => {
    const record = useRecordContext();
    // the record can be empty while loading
    if (!record) return null;

    return (<>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Title</TableCell>
                    {/* <TableCell align="right">LP</TableCell> */}
                    {/* <TableCell align="right">CP</TableCell> */}
                    {/* <TableCell align="right">MSA</TableCell> */}
                </TableRow>
                </TableHead>
                <TableBody>
                {record.indicators.map((indicator) => (<React.Fragment key={indicator.name}>
                    <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Link to={`/form-indicators/${indicator.id}/show`}>
                                {indicator.name}
                            </Link>
                        </TableCell>
                        {/* <TableCell align="right">{scoreFor('indicator', indicator).lp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('indicator', indicator).cp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('indicator', indicator).msa}</TableCell> */}
                    </TableRow>
                </React.Fragment>))}
                </TableBody>
            </Table>
        </TableContainer>
    </>);
};
const FormKeyIndicatorShow = props => (
    <Show {...props}>
        {/* <SimpleShowLayout> */}
        <TabbedShowLayout>
            <Tab label="summary">
                <TextField source="name" />

                {/* sequence */}

                <TextField label="Form" source="form_standard.form.name" />

                <TextField label="Standard" source="form_standard.name" />

            </Tab>
            <Tab label="Table of Contents">
                <em>Click on a title to navigate to that specific section.</em>
                <FormPreview/>
            </Tab>
        {/* </SimpleShowLayout> */}
        </TabbedShowLayout>
    </Show>
);

const FormStandardOptionRenderer = () => {
    const record = useRecordContext();
    return (
        <span>
            {record.name}
            <br/>
            <small>{record.form.name}</small>
        </span>
    );
}

export const FormKeyIndicatorEditForm = () => (
    <SimpleForm toolbar={<FormEditChildToolbar resource="form-key-indicators" deletable />}>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextInput source="name" isRequired fullWidth />
            </Grid>
            <Grid item xs={6}>


                {/* <TextField label="Form" source="form_standard.form.name" /> */}
                {/* <TextField label="Standard" source="form_standard.name" /> */}

                <ReferenceInput source="form_standard_id" perPage={-1} reference="form-standards">
                    <AutocompleteInput
                        isRequired
                        fullWidth
                        /*optionText="name"*/
                        optionText={<FormStandardOptionRenderer/>}
                        inputText={choice => choice.name}
                    />
                </ReferenceInput>
            </Grid>
        </Grid>

        {/* sequence */}
        {/* <NumberInput source="sequence" label="Order" /> */}

        {/* <RichTextInput source="description"/> */}
        {/* <RichTextInput source="focus_areas"/> */}
        {/* <RichTextInput source="key_indicators_description"/> */}
    </SimpleForm>
);

const FormKeyIndicatorEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic">
        <FormKeyIndicatorEditForm/>
    </Edit>
);

const FormKeyIndicatorCreate = props => {
  return (
    <Create {...props} redirect="show">
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextInput source="name" isRequired fullWidth />
                </Grid>
                <Grid item xs={6}>


                    {/* <TextField label="Form" source="form_standard.form.name" /> */}
                    {/* <TextField label="Standard" source="form_standard.name" /> */}

                    <ReferenceInput source="form_standard_id" perPage={-1} reference="form-standards">
                        <AutocompleteInput
                            isRequired
                            fullWidth
                            /*optionText="name"*/
                            optionText={<FormStandardOptionRenderer/>}
                            inputText={choice => choice.name}
                        />
                    </ReferenceInput>
                </Grid>
            </Grid>

            {/* sequence */}
            {/* <NumberInput source="sequence" label="Order" /> */}

            {/* <RichTextInput source="description"/> */}
            {/* <RichTextInput source="focus_areas"/> */}
            {/* <RichTextInput source="key_indicators_description"/> */}
        </SimpleForm>
    </Create>
)
};

export {FormKeyIndicatorList, FormKeyIndicatorShow, FormKeyIndicatorEdit, FormKeyIndicatorCreate};
